var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M10.664 3.19995C9.578 3.19995 8.606 3.67456 8 4.40265C7.394 3.67456 6.422 3.19995 5.336 3.19995C3.494 3.19995 2 4.54826 2 6.21478C2 6.85657 2.114 7.44985 2.312 7.99996C3.26 10.6966 6.182 12.3092 7.628 12.7514C7.832 12.8161 8.168 12.8161 8.372 12.7514C9.818 12.3092 12.74 10.6966 13.688 7.99996C13.886 7.44985 14 6.85657 14 6.21478C14 4.54826 12.506 3.19995 10.664 3.19995Z",
    fill: "white",
    fillOpacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.ed6c08a1f4fcaaac97c9951e4ea75dd7.svg";
export { ForwardRef as ReactComponent };